import styled from 'styled-components'
import Slider from 'react-color/lib/components/slider/Slider'

const controlPanelTileNHexSize = `
height:20px!important;
width: 64px!important;
`
const tileMargin = '5px'


const borderedStyles = `
 border: solid 1px #eaeaea;
`

const sliderDirsCollection = {
	palette: `.slider-picker &:last-child div  > div `,
	paletteItem: `div:not(.hue-horizontal) > div > div > div`,
	hue: `.hue-horizontal`

}

export const StyledColorSlider = styled(Slider)`
display:flex;
flex-direction:column;

justify-content:center;
width:170px;

${sliderDirsCollection.paletteItem}{
min-height:20px!important;
}

${sliderDirsCollection.palette}{
	margin-top:24px!important;
}

${sliderDirsCollection.hue}{
	height:19px!important;
}

`

export const StyledColorControlPanel = styled.div`
 margin-top:10px;
 padding:${tileMargin};
 display:flex;
 width:100%;
`

export const StyledColorControlBlock = styled.div`
	display:flex;
	flex-direction:column;
	width:75%;
	align-items:flex-start;

`

export const StyledLeftBlock = styled(StyledColorControlBlock)`
margin-right:${tileMargin};
	width:25%!important;

justify-content:center;

	div {
	${controlPanelTileNHexSize}
	margin-bottom:12px;
	}
	
	input {
		${controlPanelTileNHexSize}
		margin-bottom:12px;
	}
`

export const StyledTile = styled.div`
	width: 28px;
	height: 28px;
	border-radius: 3px;
	cursor: pointer;


${({ isCancel, isBordered, isExample, backgroundColor }) => `
	background:${backgroundColor}!important; 

${isCancel ? `
	position: relative;
	border: 1px solid #ff2b2b;
&:before {
		content: '';
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%) rotate(${isExample ? '-14deg' : '-45deg'});
		width: ${isExample ? '102%' : '141%'};
		height: 1px;
		background: #ff2b2b;
	}
	` : ' '}
	
${isExample ? controlPanelTileNHexSize : `
	margin: ${tileMargin};
`}
	
${isBordered ? borderedStyles : ' '} 
	
`}
`

export const StyledSliderPicker = styled.div`
width:100%!important;
`

export const StyledTriangle = styled.div`
width: 0px;
height: 0px;
border-style: solid;
border-width: 0px 9px 10px;
border-color: transparent transparent rgb(255, 255, 255);
position: absolute;
top: -10px;
left: 12px;
`

export const StyledPicker = styled.div`
z-index: 101;
position: absolute;
display: flex;
flex-wrap: wrap;
padding: 20px;
margin-top: 10px;
background-color: #fff;
box-shadow: 0 2px 4px 0 rgba(90, 90, 90, 0.12);

.slider-picker {
width:100%;
}

${({ height, width }) => `
	height:${height}px;
	width:${width}px;
	
`}
`

export const StyledHexInput = styled.input`
font-size:12px!important;
padding: 2px!important;
`

export const StyledColoredButton = styled.div`
margin: 0;
width: 140px;
height: 36px;
color: $primary-color;
font-weight: 300;
font-size: 14px;
text-align: center;
padding: 8px 0;
border: solid 0.5px rgba(195, 195, 195, 0.5);
cursor: pointer;

background-color:${({ backgroundColor }) => backgroundColor ? backgroundColor : '#fff'}
`
